<template>
    <el-row :gutter="15" style="margin: 10px">
        <el-col :span="3">
            <el-input v-on:keyup.native.enter="search" size="mini" :clearable="true" placeholder="订单号"
                      v-model.trim="id">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </el-col>

        <el-col :span="3">
            <el-input v-on:keyup.native.enter="search" size="mini" :clearable="true" placeholder="款号"
                      v-model.trim="baseId">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </el-col>
        <el-col :span="1">
            <el-button
                    icon="el-icon-search"
                    :loading="searchLoading"
                    @click="search"
                    type="primary"
                    size="mini">搜索
            </el-button>
        </el-col>

        <el-col :span="16" class="craft-content-col">
            <div>
                <el-button
                        :loading="refreshLoading"
                        icon="el-icon-refresh"
                        @click="refresh"
                        type="primary"
                        size="mini">刷新
                </el-button>
            </div>
            <slot>

            </slot>
            <div :key="index" v-for="({tagName,count_data},index) in countTags">
                <el-tag effect="plain" type="warning" size="mini">
                    <span :class="index===0 ? 'text-main' : 'text-info'">{{ tagName }}</span>
                    <template v-for="countObj in count_data">
                        <el-icon v-if="countObj.loading" class="el-icon-loading"></el-icon>
                        <el-tooltip v-else :content="countObj.title" placement="top">
                            <el-link @click="tagClick(countObj)" :underline="false" :type="countObj.type">{{
                                countObj.count }}
                                <el-divider direction="vertical"></el-divider>
                            </el-link>
                        </el-tooltip>
                    </template>
                </el-tag>
            </div>
        </el-col>
    </el-row>
</template>

<script>
    export default {
        name: "CraftSearch",
        props: {
            searchUrl: {
                type: String,
                required: true,
            },
            refreshUrl: {
                type: String,
                required: true
            },
            handleSuccess: {
                type: Function,
                required: true,
            },
            handleRefreshResponse: {
                type: Function,
                required: true,
            },
            table_work: {
                type: Number,
            },
        },
        data() {
            return {
                id: '',
                baseId: '',
                searchLoading: false,
                refreshLoading: false,
                countTags: [],
            }
        },
        methods: {
            /**
             * 刷新数量标签
             */
            refreshCountTags() {
                this.countTags.forEach(countTag => {
                    countTag.count_data.forEach(countObj => {
                        countObj.loading = true
                    })
                })

                const countTagUrl = `${this.$const.craftListUrl}count_data/?table_work=${this.table_work}`
                this.$getRequest(countTagUrl)
                    .then(response => {
                        this.countTags.length = 0
                        response.data.forEach(countTag => {
                            this.countTags.push(countTag)
                        })
                    })
            },

            /**
             * 点击标签
             * @param data
             */
            tagClick(data) {
                data.loading = true
                this.$getRequest(data.url)
                    .then(response => {
                        data.loading = false
                        this.handleRefreshResponse(response)
                    })
            },
            search() {
                this.searchLoading = true
                const params = {}
                if (this.id) {
                    params['platform_order'] = parseInt(this.id.substring(this.id.length - 5))
                }

                if (this.baseId) {
                    params['base_id'] = this.baseId
                }
                this.$getRequest(this.searchUrl, params)
                    .then(response => {
                        this.searchLoading = false
                        this.handleSuccess(response)
                    })
                    .catch(error => {
                        this.searchLoading = false
                    })
            },
            refresh() {
                this.refreshCountTags()
                this.refreshLoading = true
                this.$getRequest(this.refreshUrl)
                    .then(response => {
                        this.refreshLoading = false
                        this.handleRefreshResponse(response)
                    })
                    .catch(error => {
                        this.refreshLoading = false
                    })
            },
        },
        created() {
            this.refreshCountTags()
        }
    }
</script>

<style scoped>
    .craft-content-col {
        text-align: left
    }

    .craft-content-col div {
        float: left;
        margin: 0 4px 6px 6px;
    }
</style>